import { useEffect } from 'react';

import piwik from '../services/analytics/analytics';

export const usePageView = page => {
  useEffect(() => {
    piwik.trackPageView(page);
  }, [page]);
};
